/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTHIRDPARTYRELATIONTYPE } from './IAPTHIRDPARTYRELATIONTYPE';
import {
    IAPTHIRDPARTYRELATIONTYPEFromJSON,
    IAPTHIRDPARTYRELATIONTYPEFromJSONTyped,
    IAPTHIRDPARTYRELATIONTYPEToJSON,
} from './IAPTHIRDPARTYRELATIONTYPE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { SimplifiedLookupResponseViewModel } from './SimplifiedLookupResponseViewModel';
import {
    SimplifiedLookupResponseViewModelFromJSON,
    SimplifiedLookupResponseViewModelFromJSONTyped,
    SimplifiedLookupResponseViewModelToJSON,
} from './SimplifiedLookupResponseViewModel';
import type { ThirdPartyViewModel } from './ThirdPartyViewModel';
import {
    ThirdPartyViewModelFromJSON,
    ThirdPartyViewModelFromJSONTyped,
    ThirdPartyViewModelToJSON,
} from './ThirdPartyViewModel';

/**
 * 
 * @export
 * @interface ThirdPartySingleSection
 */
export interface ThirdPartySingleSection {
    /**
     * 
     * @type {IAPTHIRDPARTYRELATIONTYPE}
     * @memberof ThirdPartySingleSection
     */
    thirdPartyRelationType?: IAPTHIRDPARTYRELATIONTYPE;
    /**
     * 
     * @type {Array<SimplifiedLookupResponseViewModel>}
     * @memberof ThirdPartySingleSection
     */
    relationTypeOptions?: Array<SimplifiedLookupResponseViewModel>;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof ThirdPartySingleSection
     */
    hasThirdParties?: IAPYESORNO;
    /**
     * 
     * @type {ThirdPartyViewModel}
     * @memberof ThirdPartySingleSection
     */
    thirdParty?: ThirdPartyViewModel;
}

/**
 * Check if a given object implements the ThirdPartySingleSection interface.
 */
export function instanceOfThirdPartySingleSection(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ThirdPartySingleSectionFromJSON(json: any): ThirdPartySingleSection {
    return ThirdPartySingleSectionFromJSONTyped(json, false);
}

export function ThirdPartySingleSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThirdPartySingleSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'thirdPartyRelationType': !exists(json, 'ThirdPartyRelationType') ? undefined : IAPTHIRDPARTYRELATIONTYPEFromJSON(json['ThirdPartyRelationType']),
        'relationTypeOptions': !exists(json, 'RelationTypeOptions') ? undefined : ((json['RelationTypeOptions'] as Array<any>).map(SimplifiedLookupResponseViewModelFromJSON)),
        'hasThirdParties': !exists(json, 'HasThirdParties') ? undefined : IAPYESORNOFromJSON(json['HasThirdParties']),
        'thirdParty': !exists(json, 'ThirdParty') ? undefined : ThirdPartyViewModelFromJSON(json['ThirdParty']),
    };
}

export function ThirdPartySingleSectionToJSON(value?: ThirdPartySingleSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ThirdPartyRelationType': IAPTHIRDPARTYRELATIONTYPEToJSON(value.thirdPartyRelationType),
        'RelationTypeOptions': value.relationTypeOptions === undefined ? undefined : ((value.relationTypeOptions as Array<any>).map(SimplifiedLookupResponseViewModelToJSON)),
        'HasThirdParties': IAPYESORNOToJSON(value.hasThirdParties),
        'ThirdParty': ThirdPartyViewModelToJSON(value.thirdParty),
    };
}

